/* eslint-disable sonarjs/no-duplicate-string */

import {
  takeEvery, put, call,
} from 'redux-saga/effects';

import { MODALS, API_URLS, FETCH_OPTIONS } from '../constants';
import { requestPost } from '../utils/request';
import { aGetMatchTimelineRequest, aGetTennisMatchTimelineRequest } from '../reducers';
import { aSetIsFetching, aSetOpenModal } from '../reducers/common';
import { aGetMatchTimelineSuccess, aGetTennisMatchTimelineSuccess } from '../reducers/matchTimeline';

/**
 * @memberof sagas/matchTimeline
 * @async
 * @param {object} action
 */
function* getMatchTimeline(action) {
  let response;
  try {
    yield put(aSetIsFetching({
      key: FETCH_OPTIONS.GET_MATCHTIMELINE,
      value: true,
    }));

    response = yield call(
      requestPost,
      action.payload.isHistory ? API_URLS.GET_MATCH_TIMELINE_HISTORY : API_URLS.GET_MATCH_TIMELINE,
      { matchId: action.payload.matchId }, true,
    );

    if (response.status === -1) {
      throw Error(response.error.message);
    } else {
      yield put(aGetMatchTimelineSuccess({
        eventDetails: response.data.matchDetails,
        matchTimeline: response.data.matchTimeline,
      }));
    }
    yield put(aSetIsFetching({
      key: FETCH_OPTIONS.GET_MATCHTIMELINE,
      value: false,
    }));
  } catch (error) {
    yield put(aSetOpenModal({
      modal: error.modal || MODALS.GENERAL_ERROR,
      errorMessage: error.message || MODALS.GENERAL_ERROR,
      key: FETCH_OPTIONS.GET_MATCHTIMELINE,
      value: false,
    }));
  }
}

/**
 * @param {object} action
 */
function* getTennisMatchTimeline(action) {
  try {
    yield put(aSetIsFetching({
      key: FETCH_OPTIONS.GET_TENNIS_MATCHTIMELINE,
      value: true,
    }));

    const response = yield call(
      requestPost,
      API_URLS.GET_TENNIS_MATCH_TIMELINE, action.payload, true,
    );

    if (response.status === -1) {
      throw Error(response.error.message);
    } else {
      yield put(aGetTennisMatchTimelineSuccess({
        eventDetails: response.data.eventDetails,
        matchTimeline: response.data.matchTimeline,
      }));
    }
    yield put(aSetIsFetching({
      key: FETCH_OPTIONS.GET_TENNIS_MATCHTIMELINE,
      value: false,
    }));
  } catch (error) {
    yield put(aSetOpenModal({
      modal: error.modal || MODALS.GENERAL_ERROR,
      errorMessage: error.message || MODALS.GENERAL_ERROR,
      key: FETCH_OPTIONS.GET_TENNIS_MATCHTIMELINE,
      value: false,
    }));
  }
}

/**
 * @memberof sagas/matchTimeline
 * @async
 * @returns {void}
 */
export default function* oddsHistorySaga() {
  yield takeEvery(aGetMatchTimelineRequest, getMatchTimeline);
  yield takeEvery(aGetTennisMatchTimelineRequest, getTennisMatchTimeline);
}

